import React from 'react';
import LoadingSpinner from '../LoadingSpinner';
import Styled, { Title, Subtitle, Container } from './styled';

const ModalLoadingOverlay = ({ title, subtitle }) => (
  <Styled>
    <Container>
      <LoadingSpinner />
      {title && <Title>{title}</Title>}
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
    </Container>
  </Styled>
);
export default ModalLoadingOverlay;
